export type SubsProductParams = Readonly<{
    id: string
    name: string
    tier: number
}>

export class SubsProduct implements SubsProductParams {
    readonly id: string
    readonly name: string
    readonly tier: number

    constructor (params: SubsProductParams) {
        this.id = params.id
        this.name = params.name
        this.tier = params.tier

        Object.freeze(this)
    }
}